import type { LucideIcon } from 'lucide-react'
import type { IconName } from '@/types'

import {
    BookOpen,
    Bookmark,
    ChartLine,
    CircleHelp,
    CodeXml,
    Compass,
    Cpu,
    FilePlus2,
    FileSearch,
    FileText,
    FolderKanban,
    FolderOpen,
    GraduationCap,
    House,
    LayoutGrid,
    Library,
    Lightbulb,
    ListChecks,
    MessageCircleQuestion,
    MonitorPlay,
    Network,
    NotebookPen,
    Presentation,
    Route,
    Server,
    ShieldCheck,
    User,
    Workflow
} from 'lucide-react'

export const ICONS: Record<IconName, LucideIcon> = {
    'cpu': Cpu,
    'workflow': Workflow,
    'folder-kanban': FolderKanban,
    'graduation-cap': GraduationCap,
    'chart-line': ChartLine,
    'lightbulb': Lightbulb,
    'book-open': BookOpen,
    'file-text': FileText,
    'list-checks': ListChecks,
    'notebook-pen': NotebookPen,
    'presentation': Presentation,
    'folder-open': FolderOpen,
    'file-search': FileSearch,
    'message-circle-question': MessageCircleQuestion,
    'house': House,
    'library': Library,
    'layout-grid': LayoutGrid,
    'shield-check': ShieldCheck,
    'bookmark': Bookmark,
    'file-plus-2': FilePlus2,
    'circle-help': CircleHelp,
    'user': User,
    'route': Route,
    'monitor-play': MonitorPlay,
    'server': Server,
    'code-xml': CodeXml,
    'network': Network,
    'compass': Compass
}
